<template>
  <section class="section section1m">
    <div class="banner-container">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in list" :style="{backgroundImage:'url(' + item + ')'}"></swiper-slide>
        <div class="swiper-pagination"  slot="pagination" v-show="list.length>1"></div>
        <div class="swiper-button-prev" slot="button-prev" v-show="list.length>1"></div>
        <div class="swiper-button-next" slot="button-next" v-show="list.length>1"></div>
      </swiper>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'homeSection1m',

    data () {
      return {
        swiperOption: {
          autoplay: 3000,
          speed: 800,
            loop: false,
            noSwiping : true,
          pagination: '.swiper-pagination',
          grabCursor: true,
          paginationClickable: true,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev'
        },
        list:[],
        bannerData:{
          bannerList: [require('@/assets/images/mockImg/banner-m.jpg'),require('@/assets/images/mockImg/banner-m1.jpg'),require('@/assets/images/mockImg/banner-m2.jpg')],
          bannerList1: [require('@/assets/images/mockImg/e-banner-m.jpg'),require('@/assets/images/mockImg/e-banner-m1.jpg'),require('@/assets/images/mockImg/e-banner-m2.jpg')]
        }


      }
    },
    created () {
        this.list = this.$i18n.locale=='cn' ? this.bannerData.bannerList : this.bannerData.bannerList1
      
    },
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .banner-container
    rela();width: 100%;height: 6.5rem;
    .banner-wrap
      height: 6.5rem
  .swiper-container
    height: 6.5rem
    .swiper-slide
      bgCover()
    >>>.swiper-button-prev
      left .22rem;width: .2rem;height: .34rem;bgCover();background-image url("~@/assets/images/home/banner-point-left-m.png")
    >>>.swiper-button-next
      right .22rem;width: .2rem;height: .34rem;bgCover();background-image url("~@/assets/images/home/banner-point-right-m.png")
    >>>.swiper-pagination-bullet
      width: 8px;height: 8px;border 1px solid $standardColor;background-color rgba(255,255,255,.75);opacity 1;
    >>>.swiper-pagination-bullet-active
      background-color  $standardColor
</style>
